import React, { Component } from 'react'
import { FormControl, InputLabel, Select, MenuItem, Chip, ListItemIcon } from '@material-ui/core';
import { PropertyFilter, CategoryFilter } from '../../../models/SearchFilter';

import { ProductProp } from '../../../models/ProductProp';

type Props = {
    defaultValue: string
    prodProp: ProductProp,
    appliedPropertyFilters: PropertyFilter[],
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter | null) => void,
    
    replaceFilter2?: (property: ProductProp) => void
}

type State = {
    componentId: string,
    dropDown: boolean,
    defaultValueSelected: boolean
}

class PropertySelect extends Component<Props, State>{
    constructor(props: Props) {
        super(props)

        this.state = {
            componentId: this.props.prodProp.name.replace(' ', ''),
            dropDown: false,
            defaultValueSelected: this.props.appliedPropertyFilters.length > 0 ? false : true
        }

        this.onChange = this.onChange.bind(this)
    }


    onChange(e: any) {
        let propFilter: PropertyFilter;

        if (e.target.value === this.props.defaultValue){
            this.setState({defaultValueSelected: true})
            propFilter = new PropertyFilter(this.props.defaultValue, this.props.prodProp.id, this.props.defaultValue, this.props.prodProp.type)
        }
        else {
            this.setState({defaultValueSelected: false})
            let selectedPropertyOptionValue: PropertyFilter | undefined = this.props.prodProp.propertyOptions.find((fo) => fo.id === e.target.value)
            propFilter = new PropertyFilter( selectedPropertyOptionValue!.id, this.props.prodProp.id, selectedPropertyOptionValue!.value.toString(), this.props.prodProp.type)
        }

        
        if(this.props.replaceFilter2){
            let prop: ProductProp = JSON.parse(JSON.stringify(this.props.prodProp))
            prop.propertyOptions = []
            prop.propertyOptions.push(propFilter)
            this.props.replaceFilter2(prop)
        } else{
            this.props.replaceFilter(undefined, propFilter)
        }
    }


    render() {
        return (
            <div>
                <FormControl style={{ width: '100%', padding: '10px 7.5px 15px 7.5px' }}>
                    <InputLabel htmlFor={this.state.componentId}>{this.props.prodProp.name}</InputLabel>
                    <Select
                        style={{ fontWeight: this.props.appliedPropertyFilters.length === 0 ? 'unset' : 'bold'}}
                        value={
                            this.props.appliedPropertyFilters.length > 0 ? this.props.appliedPropertyFilters[0].id : this.props.defaultValue
                        }
                        onChange={this.onChange}
                        inputProps={{
                            name: 'prodProp',
                            id: this.state.componentId
                        }}
                        onOpen={() => this.setState({ dropDown: true})}
                        onClose={() => this.setState({ dropDown: false})}
                    >
                        <MenuItem value={this.props.defaultValue}>{this.props.defaultValue}</MenuItem>
                        {(this.props.prodProp.propertyOptions).map((fo, i: number) => {       
                            return (<MenuItem key={i} value={fo.id} style={{width:'100%'}}>
                                {this.state.dropDown && fo.count > 0 &&
                                    <ListItemIcon><Chip size="small" color="primary" style={{ fontWeight: "bold" }} label={fo.count}></Chip></ListItemIcon>
                                }
                                {fo.value}
                            </MenuItem>)
                        })}
                    </Select>
                </FormControl>
            </div>
        )
    }
}

export default PropertySelect